import { render, staticRenderFns } from "./ProductMaterialSelectView.vue?vue&type=template&id=a17b3cb6&scoped=true&"
import script from "./ProductMaterialSelectView.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialSelectView.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaterialSelectView.vue?vue&type=style&index=0&id=a17b3cb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17b3cb6",
  null
  
)

export default component.exports